import React, { Fragment, useState } from 'react';
import ProvinceListView from '../../../components/front_office/province/ProvinceListView';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import ProvinceEditView from '../../../components/front_office/province/ProvinceEditView';

const ProvinceCreateListView = () => {
    const { data, loading, error, refetch } = useFetchData(AppURL.FrontOfficeURL + 'front/province/details/list/view/');
    const handleFormSuccess = (): void => {
        refetch();
    };
    const [onID, setOnID] = useState<number | null>(null);
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ProvinceEditView onID={onID} handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ProvinceListView setOnID={setOnID} data={data} error={error} loading={loading} />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default ProvinceCreateListView